import React, { FunctionComponent as FC, useRef, useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // To call Action Creators
import { State } from '../../../../state';
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../state";
import './index.scss';
import _ from 'lodash';

import InitializeBubbleTreemap from './InitializeBubbleTreemap';
import EntityTypeLevelGraph2025 from './EntityTypeLevelGraph2025';
import GrantTypeNode from '../GrantTypeNode';
import EntityFieldLevelCitationFlow from '../EntityFieldLevelCitationFlow';
import EntityFieldLevelHighlighedImpactNode from '../EntityFieldLevelHighlighedImpactNode';

import { MainViewTypes } from '../../../../types/data';
import OptimizedBubbleTreemap from './OptimizedBubbleTreemap';

// // temp. TODO: move `glyphStyle` to `style.global.ts`
// import { glyphStyle } from '../GrantTypeNode';

// // opt 6 - case 2 - vis (第一段，patent, 只选patent-direct/indirect impact的时候)
// import { bubbleTreemapStyle } from '../EntityFieldLevelGraph/bubbleTreemapConfig';
// import useEntityTypeLayoutCalculation from './useEntityTypeLayoutCalculation';


// // [abandon] method 1: import from `style.global.ts`
// import { grantTypeNodeTransformXY } from '../../../../types/style.global';
// method 2: import from uiReducer > grantTypeNodeTransformXY, see code below in the component



// temp, hard code, to update in style.global.ts
// const mainviewStyle = {
//     R_svg: svgSize.mainview.height / 2,
//     // R_grantTypeNode: 180,
//     entityTypeNodeSize_alpha: 0.9,
// }
// const grantTypeNodeTransformXY ={
//     x: svgSize.mainview.width / 2, // 440,
//     y: svgSize.mainview.height / 2, // 320
// }


// interface HighlightedGrantGroupNode {
//   grantFieldID: string,
//   grantFieldName: string,
// }

interface SVGGroupWrapperProps {
    // mainviewGroupRef: React.RefObject<SVGGElement> | null;
    // svgBoundingBox: any;
    entityTypeGraphData: MainViewTypes.EntityTypeGraphData;
    entityFieldGraphData: any;
    grantNodeGlyphData: MainViewTypes.GrantNodeGlyphDataUnit[];
    predictionDataDict: MainViewTypes.PredictionResultDict;
    selectedImpactTypeList: string[];
}

const SVGGroupWrapper: FC<SVGGroupWrapperProps> = (props) => {
    const { entityTypeGraphData, entityFieldGraphData, grantNodeGlyphData, predictionDataDict, selectedImpactTypeList } = props

    const dispatch = useDispatch()
    const {
    } = bindActionCreators(actionCreators, dispatch)

    // data reducer
    // const isDrawGrantTypeNodeFinished: boolean = useSelector((state: State) => state.dataReducer?.isDrawGrantTypeNodeFinished) as boolean
    const isEntityTypeGraphFinished: boolean = useSelector((state: State) => state.dataReducer?.isEntityTypeGraphFinished) as boolean
    const isInitializeBubbleTreemapFinished: boolean = useSelector((state: State) => state.uiReducer?.isInitializeBubbleTreemapFinished) as boolean
    const isOptimizedBubbleTreemapFinished: boolean = useSelector((state: State) => state.uiReducer?.isOptimizedBubbleTreemapFinished) as boolean

    // ui reducer
    const grantTypeNodeTransformXY: MainViewTypes.GrantTypeNodeTransformXY = useSelector((state: State) => state.uiReducer?.grantTypeNodeTransformXY) as MainViewTypes.GrantTypeNodeTransformXY
    const cleanMainviewGraph: boolean = useSelector((state: State) => state.uiReducer?.cleanMainviewGraph) as boolean
    const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string
    const parts = impactType.split("_")
    const impactTypeRefined = parts.slice(0, 2).join("_")
    // console.log('impactTypeRefined: ', impactTypeRefined)



    ////////////////////  (4) draw element (start)  ////////////////////


    console.log('\n\n\n ============== SVGGroupWrapper: started! ==============\n\n')


    // avoid re-rendering
    // ✅ 生成一个稳定引用，只有 x/y 改变才会变
    const grantTransform = useMemo(
      () => ({ x: grantTypeNodeTransformXY.x, y: grantTypeNodeTransformXY.y }),
      [grantTypeNodeTransformXY.x, grantTypeNodeTransformXY.y]
    );


    //////////////////////////////////////////////////////////////////////////
    ////////////////////  nhb 2025 version (start below)  ////////////////////
    //////////////////////////////////////////////////////////////////////////

    // ======== Step 1: two parallel steps: ========

    // Step 1-1 & 1-2: 并行计算（不渲染）

    // --- 1-1 calc backbone graph (entity-type level) using force-directed layout ---
    // console.log('\n\n========== [Step 1] Component: EntityTypeLevelGraph (started!) ============')

    // method 1: write in EntityTypeLevelGraph2025.tsx
    // 1. entity-type level (force-directed graph)
    // only draw after user select impact types (右上角)
    let entityTypeLevelGraph2025: JSX.Element = <></>
    if (entityTypeGraphData && selectedImpactTypeList.length > 0 && impactType) {
      entityTypeLevelGraph2025 =  <EntityTypeLevelGraph2025
                                    entityTypeGraphData={entityTypeGraphData}
                                    selectedImpactTypeList={selectedImpactTypeList}
                                    impactType={impactType}
                                  />
    }

    // // --- 1-2 calc bubble treemap (entity-field level): for all impact types ---
    // /*
    //   input: `entityFieldGraphData`
    // */

    // method 1: write in InitializeBubbleTreemap/index.tsx
    let initializedBubbleTreemap: JSX.Element = <></>
    if (entityTypeGraphData && selectedImpactTypeList.length > 0 && impactType && impactTypeRefined) {
      initializedBubbleTreemap = <InitializeBubbleTreemap
                                    entityFieldGraphData={entityFieldGraphData}
                                    predictionDataDict={predictionDataDict}
                                    selectedImpactTypeList={selectedImpactTypeList}
                                    impactType={impactType} impactTypeRefined={impactTypeRefined}
                                  />
    }

    let optimizedBubbleTreemap: JSX.Element = <></>
    if (initializedBubbleTreemap !== <></>) {
      // console.log('---- within optimizedBubbleTreemap ----')
      optimizedBubbleTreemap = <OptimizedBubbleTreemap entityFieldGraphData={entityFieldGraphData} predictionDataDict={predictionDataDict} />
    }
    // if (entityTypeLayoutData && (entityTypeLayoutData.nodes.length > 0) && (initialBubbleTreemapEntityTypeGroupElementList) && (initialBubbleTreemapEntityTypeGroupElementList.length > 0)) {
    //   optimizedBubbleTreemap = <OptimizedBubbleTreemap bubbleTreemapEntityGroupList={bubbleTreemapEntityGroupList} svgR={svgR} entityTypeLayoutData={entityTypeLayoutData}/>
    // }




    // // Step 2: two parallel steps:
    // // --- 2-1 bubble treemap post-process: (1) scale size (by a parameter `alpha`); (2) transform position (x, y), along the edge of backbone graph in Step 1-1 ---
    // // input
    // const svgR: number = Math.min(svgSize.mainview.width, svgSize.mainview.height) / 2
    // // console.log('circumscribedRadii: ', circumscribedRadii) // impact type circle
    // // console.log('GrantGlyphGroupOuterR: ', glyphStyle.grantGlyphGroupR)
    // // console.log('svgR: ', svgR)

    // // Step 3: 串行：前两步完成后再进行布局优化
    // // const optimizedLayoutData = useLayoutOptimization(entityTypeLayoutData, bubbleTreeMapData);
    // useEffect(() => {
    //   if (!_.isEmpty(circumscribedRadii) && entityTypeLayoutData && bubbleTreemapEntityTypeGroupElementList.length > 0) {
    //     // debug
    //     console.log('circumscribedRadii: ', circumscribedRadii)
    //     console.log('entityTypeLayoutData: ', entityTypeLayoutData)
    //     console.log('bubbleTreemapEntityTypeGroupElementList: ', bubbleTreemapEntityTypeGroupElementList)

    //     // 1. prepare parameters
    //     const parameters = {
    //       svgMaxR: svgR,
    //       grantGlyphGroupR: glyphStyle.grantGlyphGroupR,
    //       circumscribedRadiiDict: circumscribedRadii,
    //       rayUnitVectorDict: entityTypeLayoutData.nodeDirections_ray_unit_vectors,
    //       relativeLengthDict: entityTypeLayoutData.nodeDistances,
    //     }

    //     // call backend function
    //     const layoutOptimization = async () => {
    //       try {
    //         console.log('getMainViewlayoutOptimizationParams(), parameters: ', parameters)
    //         const result = await getMainViewlayoutOptimizationParams(parameters)
    //       } catch (error) {
    //         console.error(error);
    //         // setIsResearcherDetailsViewLoading(false)
    //       } finally {
    //         isOptimizingMainViewLayoutFinished(true)
    //         //console.log('Researcher View update finished');
    //         // setIsResearcherDetailsViewLoading(false)
    //       }
    //     }
    //     layoutOptimization();
    //   }
    // }, [circumscribedRadii, entityTypeLayoutData, bubbleTreemapEntityTypeGroupElementList])



    // --- 2-2 grant node layout (another force-directed, mentioned in paper, three types of forces) ---
    // 2. grant glyph
    let grantTypeNode: JSX.Element = <></>
    if (grantNodeGlyphData && predictionDataDict && entityFieldGraphData && isEntityTypeGraphFinished) {
      grantTypeNode = <GrantTypeNode
                        glyphDataAll={grantNodeGlyphData}
                        entityFieldGraphData={entityFieldGraphData} // for filter topK grant field nodes, based on impactType
                        predictionData={predictionDataDict.grant_id_list_subinstitution} // to show prediction result

                        // newly added (nhb-ftf)
                        // isEntityTypeGraphFinished={isEntityTypeGraphFinished}
                        // entityFieldGraph_InputData={entityFieldGraph_InputData}
                      />
    } else if (grantNodeGlyphData && entityFieldGraphData && isEntityTypeGraphFinished) {  // case 2 - vis (no prediction result)
    // grantTypeNode = <GrantTypeNode
    //   glyphDataAll={grantNodeGlyphData}
    //   entityFieldGraphData={entityFieldGraphData} // for filter topK grant field nodes, based on impactType
    //   predictionData={{} as MainViewTypes.PredictionResult} // to show prediction result
    // />
    }

    // Step 3: calc link position and draw link
    // 4. entity-field level (hierarchical edge bundling, customized version)
    // console.log('isInitializeBubbleTreemapFinished: ', isInitializeBubbleTreemapFinished)
    // console.log('isOptimizedBubbleTreemapFinished: ', isOptimizedBubbleTreemapFinished)
    let entityFieldCitationFlowElement = <></>
    if (grantTransform && isEntityTypeGraphFinished && isInitializeBubbleTreemapFinished && isOptimizedBubbleTreemapFinished) {
    // if (grantTypeNodeTransformXY && isEntityTypeGraphFinished && isInitializeBubbleTreemapFinished && isOptimizedBubbleTreemapFinished) {
      entityFieldCitationFlowElement = <EntityFieldLevelCitationFlow
                                          grantTypeNodeTransformXY={grantTransform}
                                          // grantTypeNodeTransformXY={grantTypeNodeTransformXY}
                                          entityFieldGraphData={entityFieldGraphData}
                                          // // mainviewDataLink={mainviewData.link}
                                          // isEntityTypeGraphFinished={isEntityTypeGraphFinished}
                                          // entityFieldGraph_InputData={entityFieldGraph_InputData}
                                        />
    }
    // console.log('entityFieldCitationFlowElement: ', entityFieldCitationFlowElement)

    // 5. highlight grant field node's impact nodes
    let highlighedGrantField_ImpactNodeElement = <></>
    if (grantTransform && isEntityTypeGraphFinished && isInitializeBubbleTreemapFinished && isOptimizedBubbleTreemapFinished) {
    // if (grantTypeNodeTransformXY && isEntityTypeGraphFinished && isInitializeBubbleTreemapFinished && isOptimizedBubbleTreemapFinished) {
      highlighedGrantField_ImpactNodeElement = <EntityFieldLevelHighlighedImpactNode entityFieldGraphData={entityFieldGraphData} />
    }
    // console.log('highlighedGrantField_ImpactNodeElement: ', highlighedGrantField_ImpactNodeElement)


    // //////////////////////////////////////////////////////////////////////////
    // ////////////////////  vis 2024 version (start below)  ////////////////////
    // //////////////////////////////////////////////////////////////////////////
    // // 1. entity-type level (force-directed graph)
    // // only draw after user select impact types (右上角)
    // let entityTypeElement: JSX.Element = <></>
    // if (
    // // (showEntityTypeLevelGraph) &&
    // (entityTypeGraphData)) {
    // entityTypeElement = <EntityTypeLevelGraph
    //                     entityTypeGraphData={entityTypeGraphData}
    //                     entityFieldGraphData={entityFieldGraphData} // to add center position (x, y) for each entity type bubble treemap
    //                     svgBoundingBox={svgBoundingBox}
    //                   />
    // }

    // // 2. grant glyph
    // let grantTypeNode: JSX.Element = <></>
    // if (grantNodeGlyphData && predictionDataDict && entityFieldGraphData && isEntityTypeGraphFinished) {
    // grantTypeNode = <GrantTypeNode
    //   glyphDataAll={grantNodeGlyphData}
    //   entityFieldGraphData={entityFieldGraphData} // for filter topK grant field nodes, based on impactType
    //   predictionData={predictionDataDict.grant_id_list_subinstitution} // to show prediction result
    // />
    // } else if (grantNodeGlyphData && entityFieldGraphData && isEntityTypeGraphFinished) {  // case 2 - vis (no prediction result)
    // // grantTypeNode = <GrantTypeNode
    // //   glyphDataAll={grantNodeGlyphData}
    // //   entityFieldGraphData={entityFieldGraphData} // for filter topK grant field nodes, based on impactType
    // //   predictionData={{} as MainViewTypes.PredictionResult} // to show prediction result
    // // />
    // }

    // // 3. entity-field level (circle packing)
    // // only draw after user select to unfold entity-field level
    // // 和entity-type level不兼容，只存在一类
    // let entityFieldElement: JSX.Element = <></>
    // if (predictionDataDict) {
    // entityFieldElement = <EntityFieldLevelGraph
    //                        predictionData={predictionDataDict.grant_id_list_subinstitution} // to show prediction result
    //                        predictionDataGlobal={predictionDataDict.grant_id_list_all_institute} // to show PI card list with global PI (那些没有被这个subinstitute注意到、fund过的PI)
    //                      />
    // } else {  // case 2 - vis (no prediction result)
    // // entityFieldElement = <EntityFieldLevelGraph
    // //                        predictionData={{} as MainViewTypes.PredictionResult} // to show prediction result
    // //                        predictionDataGlobal={{} as MainViewTypes.PredictionResult} // to show PI card list with global PI (那些没有被这个subinstitute注意到、fund过的PI)
    // //                      />
    // }

    // // 4. entity-field level (hierarchical edge bundling, customized version)
    // let entityFieldCitationFlowElement = <></>
    // if (grantTypeNodeTransformXY) {
    //   entityFieldCitationFlowElement = <EntityFieldLevelCitationFlow
    //                                       grantTypeNodeTransformXY={grantTypeNodeTransformXY}
    //                                       entityFieldGraphData={entityFieldGraphData}
    //                                       // mainviewDataLink={mainviewData.link}
    //                                     />
    // }

    // // 5. highlight grant field node's impact nodes
    // let highlighedGrantField_ImpactNodeElement = <></>
    // highlighedGrantField_ImpactNodeElement = <EntityFieldLevelHighlighedImpactNode entityFieldGraphData={entityFieldGraphData} />




    ////////////////////  (4) draw element (end)  ////////////////////


    // console.log('==> entityFieldGraphData: ', entityFieldGraphData)


    console.log('============== SVGGroupWrapper: finished! ==============\n\n')



    if (cleanMainviewGraph) {
      return <></>
    } else {
      return (
        <>
          {/* nhb ftf version (2025) */}
          {entityTypeLevelGraph2025}
          {initializedBubbleTreemap}
          {optimizedBubbleTreemap}
          {entityFieldCitationFlowElement}
          {grantTypeNode}
          {highlighedGrantField_ImpactNodeElement}


          {/* <circle cx={0} cy={0} r={20} fill="red" opacity={0.5}/> */}

          {/* {
            <g opacity={0.1}>
              {bubbleTreemapEntityTypeGroupElementList}
            </g>
          } */}
          {/* {entityTypeLayoutData && (entityTypeLayoutData.nodes.length > 0) && (bubbleTreemapEntityGroupList.length > 0) && <OptimizedBubbleTreemap bubbleTreemapEntityGroupList={bubbleTreemapEntityGroupList} svgR={svgR} entityTypeLayoutData={entityTypeLayoutData}/>} */}










          {/* debug: circumscribed circles layer (外接圆of each impact type bubble) */}
          <g id="circumscribed-circles-layer">
            {/* {renderCircumscribedCircles()} */}
          </g>

          {/* debug: test center list */}
          <g id="test-center-list">
            {/* {testCenterList} */}
          </g>



          {/* vis2023 version */}
          {/* { (!_.isEmpty(entityTypeGraphData)) &&
            <g id='entity-type-graph-g'>
              {entityTypeElement}
            </g>
          }
          { (!_.isEmpty(entityFieldGraphData)) &&
            <g id='entity-field-level-graph'>
              {entityFieldElement}
              { (isDrawGrantTypeNodeFinished) && entityFieldCitationFlowElement}
              { (isDrawGrantTypeNodeFinished) && highlighedGrantField_ImpactNodeElement}
            </g>
          }
          { (!_.isEmpty(grantNodeGlyphData)) && (isEntityTypeGraphFinished) &&
            <g id="grant-field-glyph-g" transform={`translate(${grantTypeNodeTransformXY.x}, ${grantTypeNodeTransformXY.y})`}>
                {grantTypeNode}
            </g>
          } */}
        </>
      )
    }
}

export default SVGGroupWrapper;



// const drawBubbleTreemap = (
//   // main data
//   entityFieldList: any,

//   // other data
//   updatedEntityFieldData: any[],

//   // ui parameters
//   selectedImpactTypeList: string[],
//   leafNodeSizeScaleType: string, // 'pow', 'log', 'linear',
//   isShowLeafNode: boolean,
//   groupRefs: React.RefObject<{[key: string]: SVGGElement | null}>,

//   // ui interaction
//   highlightedNode: HighlightedGrantGroupNode,
//   handleMouseRightClick: (e: MouseEvent, id: string) => void,
//   handleMouseLeave: (e: MouseEvent, id: string) => void,
//   handleMouseEnter: (e: MouseEvent, id: string) => void,
//   handleMouseOnClick: (e: MouseEvent, id: string) => void,

//   // const parameters
//   padding: number,
//   curvature: number,

// ) => {
//   // find the root node, as input for the following steps
//   const rootNode = entityFieldList.find((node: any) => node.depth === 0)
//   if (!rootNode) return <></>
//   const entityType: string = rootNode.data.name

//   if (entityType === 'grant') {
//     return <></>
//   }

//   // ====== 1. calc data for drawing (start) ======
//   // 1-1 calc leaf nodes positions (bubble treemap function)
//   const hierarchyRoot_updated = lp(rootNode, padding)
//   const leafNodes: any[] = hierarchyRoot_updated.descendants().filter((node: any) => !node.children)
//   // post process: add parents (depth === 1)
//   const leafNodeDataList: any = leafNodes.map((nodeData) => {
//     // recursively to find parent node (with depth === 1) name and depth
//     let currentNode = nodeData
//     while (currentNode.parent && currentNode.parent.depth !== 1) {
//       currentNode = currentNode.parent;
//     }
//     let parentNodeData: any = {}
//     if (currentNode.parent) {
//         parentNodeData = {
//             name: currentNode.parent.data.name,
//             type: currentNode.parent.data.type,
//             depth: currentNode.parent.depth, // depth === 1 is the entity type level
//         }
//     } else {
//         parentNodeData = {
//             name: 'root\'s root',
//             type: '',
//             depth: -1, // depth === 1 is the entity type level
//         }
//     }
//     return {
//       x: nodeData.x,
//       y: nodeData.y,
//       r: nodeData.r,
//       data: {
//         name: nodeData.data.name,
//         value: nodeData.data.value,
//       },
//       'parent_entity_type': parentNodeData.name,
//     }

//   })
//   // calc leaf node size scale, used for highlight a grant field node
//   /*
//       select one impact type, and the first leaf node in this entity type, as input for calc leaf node size scale.
//       note: other impact types and leaf nodes should result in the same scale.
//   */
//   console.log('selectedImpactTypeList: ', selectedImpactTypeList)
//   console.log('leafNodeDataList: ', leafNodeDataList)
//   const exampleImpactType = selectedImpactTypeList[0]
//   const leafNodeList_ImpactType = leafNodeDataList.filter((node: any) => node.parent_entity_type === exampleImpactType)
//   const exampleNode = leafNodeList_ImpactType[0]
//   const value = exampleNode.data.value
//   const r = exampleNode.r
//   const leafNodeSizeScale = extractScaleFactor(value, r, leafNodeSizeScaleType)

//   // 1-2 calc contour paths (bubble treemap function)
//   const contourListData = contourHierarchy(hierarchyRoot_updated, padding, curvature)


//   // ====== 2. draw JSX elements (start) ======
//   // 2-1 draw leaf nodes and contour
//   /*
//       input: `leafNodeDataList`, `contourListData`
//       method: first, group elements (leaf nodes + contour) by entity type groups; second, draw entity type group one by one
//   */
//   // for each entity type, draw leaf nodes and contour:
//   const bubbleTreemapEntityGroupList: MainViewTypes.BubbleTreemapEntityTypeGroup[] = []
//   const entityList = selectedImpactTypeList
//   _.forEach(entityList, (impactType, idx) => {
//     if (selectedImpactTypeList.includes(impactType)) {
//       // filter element in this group
//       const leafNodeList_ImpactType = leafNodeDataList.filter((node: any) => node.parent_entity_type === impactType)
//       const contourList_ImpactType = contourListData.filter(contour => contour.parent_entity_type === impactType)

//       // find entity type force-directed graph node position
//       const entityTypeGraph_NodePosition = updatedEntityFieldData.find(entity => entity.name === impactType)

//       // find rootNode's children - this entity's r
//       const entityTypeEntity = rootNode.children.find((node: any) => node.data.name === impactType)

//       // generate JSX Element
//       if ((leafNodeList_ImpactType.length > 0) && (contourList_ImpactType.length > 0) && (entityTypeGraph_NodePosition)){
//         // (1) draw leaf node
//         const leafNodeElementList: JSX.Element[] = leafNodeList_ImpactType.map((node: any, idx: number) => {
//           // set text label
//           let textInfo: string = node.data.name
//           if (impactType === 'newsfeed' || impactType === 'policy') {
//             // pass
//           } else if (impactType === 'patent') {
//             // textInfo = cpcCode2Name[node.data.name]
//           } else if (impactType === 'clinical_trial') {
//             // textInfo = meshCode2Name[node.data.name]
//           } else if (impactType === 'paper') {
//             // pass
//           } else {
//             console.log('error: unknown impact type')
//           }

//           // set fill color
//           let fill = "url(#leaf-node-fill)"
//           // console.log('highlghtedGrantFieldNode: ', highlghtedGrantFieldNode)
//           if (highlightedNode.grantFieldID === node.data.name && highlightedNode.grantFieldName === impactType) {
//             fill = 'url(#leaf-node-fill-predict)'
//           } else if (highlightedNode.grantFieldID === '' && highlightedNode.grantFieldName === '') {
//             fill = "url(#leaf-node-fill)"
//           } else {
//             fill = 'none'
//           }

//           let opacity = 1
//           if (isShowLeafNode === false) {
//             opacity = 0
//             // if (highlghtedGrantFieldNode.grantFieldID === '') {
//             //   opacity = 1
//             // }
//           }

//           return (
//             <g key={`leaf-node-${node.data.name}-${impactType}`} id={`leaf-node-${node.data.name}-${impactType}`}
//                 style={{ cursor: 'pointer' }}
//                 onMouseEnter={(e) => {
//                   // console.log('hover!!!!!')
//                   const id = e.currentTarget.id
//                   handleMouseEnter(e as unknown as MouseEvent, id)
//                 }}
//                 onMouseLeave={(e) => {
//                   // console.log('leave!!!!!')
//                   const id = e.currentTarget.id
//                   handleMouseLeave(e as unknown as MouseEvent, id)
//                 }}
//                 onClick={(e) => {
//                   // console.log('down!!!!!')
//                   const id = e.currentTarget.id
//                   handleMouseOnClick(e as unknown as MouseEvent, id)
//                 }}
//             >
//               <circle id={`leaf-node-r={${node.r}}-value={${node.data.value}}-${node.data.name}-${impactType}`}
//                 cx={node.x} cy={node.y} r={Math.pow(node.r, 1)} // r={node.r}
//                 // fill="#6F999B"
//                 // fill={node.depth === 0 ? "red" : node.children ? "grey" : "steelblue"}
//                 // filter="url(#frosted-glass-effect)"
//                 // fill="url(#leaf-node-filter-2)"
//                 // fill="url(#leaf-node-fill)"
//                 fill={fill}
//                 opacity={ opacity }
//                 // opacity={ (isShowLeafNode) ? 1 : 0}
//                 // stroke="transparent" strokeWidth={4}
//               />
//               <text x={node.x} y={node.y} dy=".35em" textAnchor="middle" fill="white" fontSize={14}>
//                 {textInfo}
//               </text>
//             </g>
//           )
//         })
//         // (2) draw contour
//         let fill = "url(#counter-node-fill)"
//         if (highlightedNode.grantFieldName === impactType) {
//           fill = 'url(#counter-node-fill-predict)'
//         } else if (highlightedNode.grantFieldID === '' && highlightedNode.grantFieldName === '') {
//           fill = "url(#counter-node-fill)"
//         } else {
//           fill = 'none'
//         }
//         const contourElementList: JSX.Element[] = contourList_ImpactType.map((arc, idx) => (
//           <path key={`${idx}`} id={`${idx}`} d={arc.d} transform={arc.transform}
//                 filter="url(#frosted-glass-effect)"
//                 fill={fill}
//                 // fill="url(#counter-node-fill)"
//                 fillOpacity={0.5}
//                 stroke="white" strokeWidth={1}  strokeOpacity={1}
//                 // fill="#6F999B"
//                 // fillRule="evenodd"
//           />
//         ))

//         // (3) draw current impact type bubble treemap group
//         // set position transformation for each impact type node's text label
//         const centerX: number = _.meanBy(leafNodeList_ImpactType, 'x')
//         const centerY: number = _.meanBy(leafNodeList_ImpactType, 'y')
//         let dx = 0
//         let dy = 0
//         // let rotate = 0
//         // if (impactType === 'patent') {
//         //   dx = 150
//         //   dy = 0
//         // } else if (impactType === 'clinical_trial') {
//         //   dx = -80
//         //   dy = 120
//         // } else if (impactType === 'policy') {
//         //   dx = -100
//         //   dy = 0
//         //   // rotate = 40
//         // }

//         bubbleTreemapEntityGroupList.push({
//           entityType: impactType,
//           JSXElement: (
//             <g
//               ref={(el) => groupRefs.current && (groupRefs.current[impactType] = el)}
//               key={impactType}
//               id={`bubble-treemap-${impactType}-g`}
//               // transform={`translate(${-centerX + entityTypeGraph_NodePosition.x}, ${-centerY + entityTypeGraph_NodePosition.y})`}
//               // // transform={`translate(${-centerX + entityTypeGraph_NodePosition.x}, ${-centerY + entityTypeGraph_NodePosition.y}) rotate(${rotate}, ${centerX}, ${centerY})`}

//               onContextMenu={(e) => {
//                 // console.log('right click the context menu: ')
//                 e.preventDefault()
//                 const id = e.currentTarget.id
//                 handleMouseRightClick(e as unknown as MouseEvent, id)
//               }}
//             >
//               {contourElementList}
//               {leafNodeElementList}
//               <text id={`bubble-treemap-text-label-${impactType}`} transform={`translate(${centerX + dx}, ${centerY + dy})`} fontSize={14} fill="#404040">{impactType}</text>
//               {/* debug: 这个entity type的最大的圆 */}
//               {/* <circle id={`debug-${entityTypeEntity.data.name}`} cx={entityTypeEntity.x} cy={entityTypeEntity.y} r=
//                 {entityTypeEntity.r} fill='red' opacity={0.5} /> */}
//             </g>
//           ),
//           center: {
//             x: centerX,
//             y: centerY,
//           }
//         })
//       } else {
//         bubbleTreemapEntityGroupList.push(
//           {
//             entityType: impactType,
//             JSXElement: (
//               // temp, to update transform with force-directed result
//               <g key={impactType} id={impactType}></g>  // empty element group
//             ),
//             center: {
//               x: 0,
//               y: 0,
//             }
//           }
//         )
//       }
//     }
//   })

//   // 2-2 init edge bundling data (record leaf node positions)
//   const leafNodePositions: MainViewTypes.LeafNodePosition[] = []
//   leafNodeDataList.forEach((leafNodeData: any) => {
//     leafNodePositions.push({
//       x: leafNodeData.x,
//       y: leafNodeData.y,
//       r: leafNodeData.r,
//       data: {
//         name: leafNodeData.data.name,
//         value: leafNodeData.data.value,
//         entityType: leafNodeData.parent_entity_type,
//       },
//     })
//   })
//   console.log('leafNodePositions: ', leafNodePositions)

//   return { bubbleTreemapEntityGroupList, leafNodePositions, leafNodeSizeScale, leafNodeSizeScaleType }
// }